import DocumentRequest from "../ws/DocumentRequest";
import WorkerRequest from "../../worker/ws/WorkerRequest";
import MachineRequest from "../../machines/ws/MachineRequest";
import CompanyRequest from "../../company/ws/CompanyRequest";

export const DOCUMENT_FORM_SET_DOCUMENT = 'document-form-set-document';
export const DOCUMENT_FORM_UPDATE_WORKER_DOCUMENT = 'document-form-update-worker-document';
export const DOCUMENT_FORM_UPDATE_MACHINE_DOCUMENT = 'document-form-update-machine-document';
export const DOCUMENT_FORM_UPDATE_COMPANY_DOCUMENT = 'document-form-update-company-document';
export const DOCUMENT_FORM_ERROR = 'document-form-error';
export const DOCUMENT_FORM_SET_LOADING = 'document-form-set-loading';
export const DOCUMENT_FORM_CLEAR_DOCUMENT = 'document-form-clear-document';

export const getDocument = (id) => (dispatch) => {

    new DocumentRequest(id)
        .onPreExecution(() => {
            dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: true });
        })
        .onSuccess(response => {
            dispatch({
                type: DOCUMENT_FORM_SET_DOCUMENT,
                payload: response,
            });
        })
        .onFail(error => {
            dispatch({ type: DOCUMENT_FORM_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: false });
        })
        .execute();

};


export const clearDocument = () => ({
  type: DOCUMENT_FORM_CLEAR_DOCUMENT
});

export const getDocumentWorker = (id) => (dispatch) => {

  new WorkerRequest(id)
    .onPreExecution(() => {
      dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: DOCUMENT_FORM_UPDATE_WORKER_DOCUMENT,
        payload: data,
      });
    })
    .onFail(error => {
      dispatch({ type: DOCUMENT_FORM_ERROR, payload: error });
    })
    .onPostExecution(() => {
      dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: false });
    })
    .execute();

};

export const getDocumentMachine = (id) => (dispatch) => {

  new MachineRequest(id)
    .onPreExecution(() => {
      dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: DOCUMENT_FORM_UPDATE_MACHINE_DOCUMENT,
        payload: data,
      });
    })
    .onFail(error => {
      dispatch({ type: DOCUMENT_FORM_ERROR, payload: error });
    })
    .onPostExecution(() => {
      dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: false });
    })
    .execute();

};

export const getDocumentCompany = (id) => (dispatch) => {

  new CompanyRequest(id)
    .onPreExecution(() => {
      dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: DOCUMENT_FORM_UPDATE_COMPANY_DOCUMENT,
        payload: data,
      });
    })
    .onFail(error => {
      dispatch({ type: DOCUMENT_FORM_ERROR, payload: error });
    })
    .onPostExecution(() => {
      dispatch({ type: DOCUMENT_FORM_SET_LOADING, payload: false });
    })
    .execute();

};


// WEBPACK FOOTER //
// ./src/app/documents/actions/documentFormActions.js